/* eslint-disable react-hooks/exhaustive-deps */
// TODO: Move these event listeners into a saga and pull the status from the store
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get, some } from 'lodash'

import useSafMode from '../hooks/useSafMode'
import { setSafMode } from '../actions/appState'

import NetworkIndicator from '../components/NetworkIndicator'
import { primaryNetworkConnectedWithCallbacks, networkSignal, setNetworkAvailableValue, getNetworkAvailableValue } from '../utils/networkConnected'
import createDataDogLog from '../utils/datadog'

// TODO(mkramerl): Resolve the reloading of this component, which is also impacting network calls.

const locationBlackList = ['card-reader', 'split-tender', 'ticket', 'signature', 'rich-checkout', 'qr-pay', 'tender-selection']

const NetworkIndicatorWrapper = ({ text, onClick, className }) => {
  const [speed, setSpeed] = useState(0)
  const pingRef = useRef()
  const [updateSafMode, getSafModeFromBridge, { safMode }] = useSafMode(null, true)

  const startPinging = () => {
    stopPinging()
    const ping = () => {
      primaryNetworkConnectedWithCallbacks(() => setNetworkAvailableValue(true), () => setNetworkAvailableValue(false))
      networkSignal(setSpeed)

      getSafModeFromBridge()
    }

    ping()
    pingRef.current = setInterval(ping, 10000)
  }

  const stopPinging = () => {
    clearInterval(pingRef.current)
    pingRef.current = undefined
  }

  useEffect(() => {
    // Do not utilize window event listeners as they will only provide network availability not
    // internet availability.

    const updateAvailability = (event) => {
      const available = event.type === "online"

      // Always ensure pinging is happening.
      if (!pingRef.current) startPinging()

      // Offline listening is reliable. If the app loses LAN, it loses internet.
      if (!available) setNetworkAvailableValue(false)

      // Old "always active" logic. Deprecated by the above.
      // if (available && !pingRef.current) startPinging()
      // if (!available && pingRef.current) stopPinging()

      // setAvailable(available)
    }

    startPinging()

    window.addEventListener('offline', updateAvailability)
    window.addEventListener('online', updateAvailability)

    return () => {
      stopPinging()
      window.removeEventListener('online', updateAvailability)
      window.removeEventListener('offline', updateAvailability)
    }
  }, [])

  return <NetworkIndicator speed={speed} text={text} onClick={onClick} className={className} />
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const push = get(ownProps, 'history.push', () => {})

  return {
    onClick: () => {
      createDataDogLog('info', 'Network Indicator Tapped')

      if (!some(locationBlackList, (pathname) => ownProps?.location?.pathname?.includes(pathname))) {
        push('/debug-info')
      }
    }
  }
}

export default withRouter(connect(null, mapDispatchToProps)(NetworkIndicatorWrapper))
